import { getAxiosInstance } from '@/services/axiosConfig';

const axiosInstance = getAxiosInstance();

export const updateAutoApproveVerifiedModels = (workspaceId: string, shouldAutoApproveVerifiedModels: boolean) =>
  axiosInstance.put(`/v1/workspaces/${workspaceId}`, { shouldAutoApproveVerifiedModels });
